
export const ProgressBarStyle = {
    progressBarBackground: '#DBD6FF',
    progressBarColor: '#4C0EA7'
};
